import { render, staticRenderFns } from "./purchaseList.vue?vue&type=template&id=1f5c3172&scoped=true"
import script from "./purchaseList.vue?vue&type=script&lang=js"
export * from "./purchaseList.vue?vue&type=script&lang=js"
import style0 from "./purchaseList.vue?vue&type=style&index=0&id=1f5c3172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5c3172",
  null
  
)

export default component.exports